import { render } from "./add-section-modal.vue?vue&type=template&id=05cf5ba9"
import script from "./add-section-modal.vue?vue&type=script&lang=js"
export * from "./add-section-modal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__